module.exports = __webpack_public_path__ + "img/logo.16f84d12.png";